import { avoidChecks, esChecks } from './checkutils';
import { captureTableImage, getEventTime } from './utils';

export const createCaption = (table, data, eventName) => {
  let eventTime = getEventTime(data);
  const title = document.createElement('caption');
  const titleBox = document.createElement('div');
  titleBox.classList.add('ect-caption-box');

  const gvTime = document.createElement('span');
  gvTime.innerHTML = `GV time: ${eventTime.gv_time}`;
  gvTime.classList.add('ect-time');

  const titleTextBox = document.createElement('p');
  const titleText = document.createElement('span');
  titleText.innerHTML = `Event Comparison: ${eventName}`;

  const captureBtn = document.createElement('button');
  captureBtn.innerHTML = '📷';
  captureBtn.className = 'ect-capture-btn';
  captureBtn.title = 'Take table screenshot';
  captureBtn.addEventListener('click', function () {
    captureTableImage(table.id);
  });

  const dltBtn = document.createElement('button');
  dltBtn.innerHTML = '🗑️';
  dltBtn.className = 'ect-dlt-btn';
  dltBtn.title = 'Hide table';
  dltBtn.addEventListener('click', function () {
    removeAccordian(table.id);
  });

  titleTextBox.append(titleText, captureBtn, dltBtn);

  const gaTime = document.createElement('span');
  gaTime.innerHTML = `GA time: ${eventTime.ga_time}`;
  gaTime.classList.add('ect-time');

  titleBox.append(gvTime, titleTextBox, gaTime);
  title.append(titleBox);

  title.className = 'table-title';
  table.appendChild(title);
};

export const addBadges = (table, eventStats, isUpdate) => {
  if (!eventStats) return;
  const badgeNode = document.querySelector(
    `#accordian_${table.id} .ect-badges`
  );

  const { isUPPaased, isCDDataPassed, isTopParamsPassed } = eventStats;

  const userPropertyBadge = getBadge('UP', isUPPaased, isUpdate, table.id);
  userPropertyBadge.dataset.upstatus = isUPPaased;

  const cdBadge = getBadge('CD', isCDDataPassed, isUpdate, table.id);
  cdBadge.dataset.cdstatus = isCDDataPassed;

  const topBadge = getBadge('Es', isTopParamsPassed, isUpdate, table.id);
  topBadge.dataset.esstatus = isTopParamsPassed;

  if (isUpdate) return;
  badgeNode.appendChild(topBadge);
  badgeNode.appendChild(cdBadge);
  badgeNode.appendChild(userPropertyBadge);
};

const getBadge = (label, status, isUpdate, id) => {
  let badge;
  if (isUpdate) {
    badge = document.getElementById(`badge_${label}_${id}`);
  }
  if (!badge) {
    badge = document.createElement('div');
    badge.classList.add('ect-badge');
    badge.id = `badge_${label}_${id}`;
    badge.innerHTML = label;
  }
  badge.classList.add(status ? 'ect-badge-pass' : 'ect-badge-fail');
  return badge;
};

export const createGroupInTable = (table, groups, isHead) => {
  const row = document.createElement('tr');

  row.className = isHead
    ? 'event-comparison-table-colhead'
    : 'event-comparison-table-grouphead';
  for (let i of groups) {
    const cell = document.createElement('th');

    cell.innerText = `${i}`;
    row.appendChild(cell);
  }

  table.appendChild(row);
};
export const createRows = (obj1 = {}, obj2 = {}, table, data) => {
  // Get unique keys from both objects
  const properties = new Set([
    ...Object.keys(obj1 || {}),
    ...Object.keys(obj2 || {}),
  ]);

  properties.forEach((key) => {
    const row = document.createElement('tr');

    const cell1 = fillColData(obj1, key);

    // Fill GA column
    const cell2 = fillColData(obj2, key);
    const cell3 = checkColData(obj1, obj2, key, data);

    if (cell1 && cell2 && cell3) {
      row.appendChild(cell1);
      row.appendChild(cell2);
      row.appendChild(cell3);
      table.appendChild(row);
    }
  });
};
const fillColData = (obj, key) => {
  const cell = document.createElement('td');
  cell.innerHTML = `<b>${key}:</b> `;
  let objValue = obj[key];

  if (Object.hasOwn(obj, key) && objValue !== undefined) {
    if (typeof objValue === 'object' || key === 'items') {
      if (objValue === null) {
        cell.innerHTML += `null`;
      } else if (objValue.value !== undefined) {
        cell.innerHTML += `${objValue.value}`;
      } else {
        try {
          objValue =
            typeof objValue === 'string' ? JSON.parse(objValue) : objValue;
        } catch (e) {
          console.info(e);
        }
        if (key === 'items') {
          cell.innerHTML += `<details>
                                  <summary>{Object}</summary>
                                  <pre>${JSON.stringify(objValue, null, 2)}</pre>
                              </details>`;
        } else {
          return null;
        }
      }
    } else {
      cell.innerHTML += `${objValue}`;
    }
  } else {
    cell.innerHTML = '-'; // Keep blank if not present
  }
  return cell;
};
const checkColData = (obj1, obj2, key, data) => {
  const cell = document.createElement('td');
  cell.classList.add('ev-com-checkbox');

  let v1 = obj1[key];
  let v2 = obj2[key];
  if (v1 !== undefined && v2 !== undefined) {
    if (v1 == v2) {
      cell.classList.add('ev-com-correct');
      cell.innerHTML = '✔️';
    } else if (typeof v1 === 'object' && typeof v2 === 'object') {
      if (JSON.stringify(v1) === JSON.stringify(v2)) {
        cell.classList.add('ev-com-correct');
        cell.innerHTML = '✔️';
      } else {
        cell.classList.add('ev-com-incorrect');
        cell.innerHTML = '❌';
      }
    } else if (
      typeof v2 === 'object' &&
      v2.value !== undefined &&
      v1 == v2.value
    ) {
      cell.classList.add('ev-com-correct');
      cell.innerHTML = '✔️';
    } else {
      cell.classList.add('ev-com-incorrect');
      cell.innerHTML = '❌';
    }
  } else if (avoidChecks(key)) {
    cell.classList.add('ev-com-correct');
    cell.innerHTML = '↔️';
  } else if (esChecks(data, key)) {
    cell.classList.add('ev-com-correct');
    cell.innerHTML = '✔️';
  } else {
    cell.classList.add('ev-com-incorrect');
    cell.innerHTML = '❌';
  }
  return cell;
};

const createJsonCol = (obj) => {
  const cell = document.createElement('td');

  if (obj) {
    let data = JSON.stringify(obj, null, 2);
    const dt = document.createElement('details');
    const sum = document.createElement('summary');
    sum.innerHTML = 'Check Actual payload';
    dt.appendChild(sum);
    const pre = document.createElement('pre');
    const cpbtn = document.createElement('button');
    cpbtn.onclick = () => navigator.clipboard.writeText(data);
    cpbtn.innerHTML = '📋 copy';
    cpbtn.className = 'ect-copybtn';
    pre.appendChild(cpbtn);
    pre.append(data);
    dt.append(pre);
    cell.append(dt);
  } else {
    cell.innerHTML = 'Event not triggered yet';
  }

  return cell;
};
export const createJsonRow = (obj1, obj2, table) => {
  const row = document.createElement('tr');

  const cell1 = createJsonCol(obj1);
  const cell2 = createJsonCol(obj2);
  row.appendChild(cell1);
  row.appendChild(cell2);
  table.appendChild(row);
};

export const removeAccordian = (id) => {
  document.getElementById(`table_header_${id}`)?.remove();
};
